import type { CentralEventGuest } from "./central-event-guests";

export function generatePublicCentralEventUrl(
  funeralHomeId: string,
  slug: string,
  eventId: string,
  mode: "rsvp" | "check-in",
  origin = "https://wehonorhome.web.app",
) {
  const base = origin.replace(/\/+$/, "");
  return `${base}/memorial/${encodeURIComponent(funeralHomeId)}/${encodeURIComponent(slug)}?event=${encodeURIComponent(eventId)}&mode=${mode}`;
}

export function eventGuestsToCsv(guests: readonly CentralEventGuest[]) {
  const rows: Array<Array<string | number>> = [
    ["Name", "Email", "Phone", "Relationship", "RSVP", "Party Size", "Checked In", "Check-In Method", "Consent", "Source", "Note"],
    ...guests.map((guest) => [
      guest.name,
      guest.email,
      guest.phone,
      guest.relationship,
      guest.responseStatus,
      guest.partySize,
      guest.checkedInAt ?? "",
      guest.checkInMethod,
      guest.consent,
      guest.source,
      guest.note,
    ]),
  ];
  return rows.map((row) => row.map(csvCell).join(",")).join("\n");
}

function csvCell(value: string | number) {
  const text = String(value ?? "");
  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

/** A shared tablet never receives a guest receipt or contact data in its URL. */
export function generatePublicRegisterUrl(funeralHomeId: string, slug: string, eventId: string, origin = "https://wehonorhome.web.app") {
  return `${origin.replace(/\/+$/, "")}/memorial/${encodeURIComponent(funeralHomeId)}/${encodeURIComponent(slug)}/register?event=${encodeURIComponent(eventId)}`;
}
